module.exports = __webpack_public_path__ + "img/19ne.4b926118.svg";